<template>
  <v-dialog :value="value" @click:outside="$close" width="450">
    <v-card>
      <v-card-title>Оценить клиента</v-card-title>
      <v-card-text>
        <validation-observer v-slot="{handleSubmit}" ref="formObs">
          <form @submit.prevent="handleSubmit(submit)">
            <custom-input-text
                type="number"
                name="оценка"
                rules="required|max_value:100"
                min="0"
                v-model="ratingData.ball"
                max="100"
            />
            <v-btn :loading="loading" type="submit" width="100%" color="primary">Оценить</v-btn>
          </form>
        </validation-observer>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>


<script>
import CustomDialogMixin from "@/configuration/mixins/CustomDialogMixin";
import {messages} from "@/utils/constants";

export default {
  name: 'RatingDialog',
  props: {
    credit_id: {
      required: true
    }
  },
  data() {
    return {
      ratingData: {
        ball: null
      },
      loading: false
    }
  },
  mixins: [CustomDialogMixin()],
  methods: {
    async submit() {
      try {
        this.loading = true
        await this.$http.post(`admin/credit/user-ball/${this.credit_id}`, this.ratingData)
        this.$emit('rated', this.ratingData.ball)
        this.$close()
        this.resetForm()
        this.$setSuccess({text: messages.onSave})
      } catch (e) {
        this.$setResponseError({error: e})
      } finally {
        this.loading = false
      }
    },
    resetForm() {
      const {formObs} = this.$refs
      this.ratingData = {ball: null}
      if (formObs) {
        formObs.reset()
      }
    }
  }
}
</script>